import React from "react";
import { components } from "react-select";

const DropdownIndicator = (props: any) => {
  const { selectProps } = props;

  return (
    <components.DropdownIndicator {...props}>
      <div className={`arrow ${selectProps.menuIsOpen ? "up" : ""}`} />
    </components.DropdownIndicator>
  );
};

export default DropdownIndicator;
